import { useTranslation } from 'react-i18next'

import Text from '../../Text'
import { FieldVariableCardItem } from '../FieldVariableCardItem'

import * as styles from './FieldVariableCard.module.css'

function FieldVariableCard({ fieldVariables, ref, style }) {
  const { t } = useTranslation()

  return (
    <div className={styles.card} ref={ref} style={style}>
      <Text isSecondary className={styles.title}>
        {t('FieldVariable.CardTitleKey')}
      </Text>
      {fieldVariables.map(fieldVariable => (
        <FieldVariableCardItem
          fieldVariable={fieldVariable}
          key={fieldVariable.name}
        />
      ))}
    </div>
  )
}

export default FieldVariableCard
